/**
 * Client tool: get_current_context
 *
 * This wraps the backend tool by getting the current path, URL, and host and calling the backend.
 *
 * Params JSON Schema:
{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "title": "GetCurrentContext Tool Params",
  "name": "get_current_context",
  "description": "Return current page context IDs parsed from the URL path. This is useful for tools that need to know the current context (organization, workflow, step, workflow execution) to perform their actions. If workflow_execution_id or step_id is found, the tool will automatically fill in organization_id and workflow_id from the database.",
  "parameters": {
    "type": "object",
    "properties": {},
    "additionalProperties": true
  }
}
 *
 * Returns JSON Schema:
 * {
 *   "$schema": "http://json-schema.org/draft-07/schema#",
 *   "title": "GetCurrentContext Tool Result",
 *   "type": "object",
 *   "properties": {
 *     "current_path": { "type": "string" },
 *     "current_url": { "type": "string" },
 *     "current_host": { "type": "string" },
 *     "organization_id": { "type": ["string", "null"] },
 *     "workflow_id": { "type": ["string", "null"] },
 *     "step_id": { "type": ["string", "null"] },
 *     "workflow_execution_id": { "type": ["string", "null"] }
 *   },
 *   "required": ["current_path", "current_url", "current_host", "organization_id", "workflow_id", "step_id", "workflow_execution_id"],
 *   "additionalProperties": false
 * }
 */
import { getCsrfToken } from './getCsrfToken.js';

export const getCurrentContext = async () => {
  const current_path = globalThis?.location?.pathname || '';
  const current_url = globalThis?.location?.href || '';
  const current_host = globalThis?.location?.origin || '';

  const response = await fetch('/chat_kit_tools/get_current_context/call', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      path: current_path,
      current_url: current_url,
      current_host: current_host
    }),
  });

  if (!response.ok) {
    let errorMessage = `Failed to get current context: ${response.status}`;
    try {
      const json = await response.json();
      errorMessage = json?.error || errorMessage;
    } catch {
      // Response body is not valid JSON, use default error message
    }
    throw new Error(errorMessage);
  }

  return await response.json();
};
